import {
  Colors,
  Spacing,
  TextStyles,
  FontWeights,
} from "@batmaid/design-tokens";

interface SimpleObject {
  [k: string]: string;
}

export type Viewports = "mobile" | "tablet" | "desktop" | "desktopLarge";
export enum VIEWPORTS {
  MOBILE = "mobile",
  TABLET = "tablet",
  DESKTOP = "desktop",
  DESKTOP_LARGE = "desktopLarge",
}

export interface DesignSystemSocialPalette {
  facebook: string;
  instagram: string;
  twitter: string;
  googleplus: string;
  youtube: string;
  google: string;
  wincasa: string;
}

interface DesignSystemFontSizes extends SimpleObject {
  h1: string;
  h2: string;
  h3: string;
  h4: string;
  h5: string;
  h6: string;
  body: string;
  body2: string;
  subtitle: string;
  subtitle2: string;
  caption: string;
  overline: string;
}

interface DesignSystemLineHeights {
  normal: string;
  h1: string;
  h2: string;
  h3: string;
  h4: string;
  h5: string;
  h6: string;
  subtitle: string;
  subtitle2: string;
  caption: string;
  overline: string;
}

interface DesignSystemFontWeights {
  light: number;
  normal: number;
  semibold: number;
  bold: number;
}

interface DesignSystemLetterSpacings {
  normal: string;
  h1: string;
  h2: string;
  h3: string;
  h4: string;
  h5: string;
  h6: string;
  subtitle: string;
  subtitle2: string;
  caption: string;
  overline: string;
}

export interface DesignSystemIconSizes {
  base: number;
  base_x1_5: number;
  base_x2: number;
  base_x3: number;
  base_x4: number;
  base_x5: number;
  base_x6: number;
  base_x7: number;
  base_x8: number;
}

interface DesignSystemMargins extends SimpleObject {
  none: string;
  quarter: string;
  half: string;
  base: string;
  base_x1_5: string;
  base_x2: string;
  base_x3: string;
  base_x4: string;
  base_x5: string;
  base_x6: string;
  base_x7: string;
  base_x8: string;
  base_x9: string;
  base_x10: string;
}

export interface DesignSystemBreakpoints {
  largeMobile: string;
  smallTablet: string;
  tablet: string;
  smallDesktop: string;
  desktop: string;
  largeDesktop: string;
}

export interface ITheme {
  animations: {
    durationShort: string;
    duration: string;
    durationLong: string;
    easing: string;
  };
  /**
   * @deprecated please use the breakpointsV2 instead
   */
  breakpoints: {
    belowMobileSmall: string;
    mobile: string;
    upToTablet: string;
    tablet: string;
    upToDesktop: string;
    tabletToDesktop: string;
    desktop: string;
    upToDesktopLarge: string;
    desktopToDesktopLarge: string;
    desktopLarge: string;
  };
  breakpointsV2: DesignSystemBreakpoints;
  buttons: {
    borderRadius: string;
    height: string;
    heightSmall: string;
    lineHeight: string;
    sizes: SimpleObject;
    paddings: SimpleObject;
  };
  border: {
    radius: {
      half: string;
      base: string;
      base_x1_5: string;
      base_x2: string;
    };
  };
  container: {
    mobile: string;
    tablet: string;
    desktopSmall: string;
    desktop: string;
    desktopLarge: string;
    calendar: string;
  };
  gradients: {
    blue800_blue600: string;
    lightblue_white: string;
  };
  socialPalette: DesignSystemSocialPalette;
  palette: Colors;
  spacing: Spacing;
  texts: TextStyles;
  fontWeights: FontWeights;
  notifications: SimpleObject;

  /**
   * @deprecated please use the texts instead
   */
  fonts: {
    default: string;
    base: string;
    baseSize: string;
    sizes: DesignSystemFontSizes;
    lineHeights: DesignSystemLineHeights;
    weights: DesignSystemFontWeights;
    letterSpacings: DesignSystemLetterSpacings;
  };
  grid: {
    columns: number;
  };
  margins: DesignSystemMargins;
  icons: {
    sizes: DesignSystemIconSizes;
  };
  name: string;
  orientation: {
    landscape: string;
    portrait: string;
  };
  zIndex: {
    modal: number;
    backdrop: number;
    header: number;
    bottomNavigation: number;
    corruptedSession: number;
    loadingIndicator: number;
    bottomSheet: number;
  };
}
